<template>
  <div class="workbench-left">

    <div class="catalog-card">

      <div class="catalog-title">
        页面目录
      </div>

      <div
        v-for="item in menuList"
        :key="item.key"
        :class="[
          'catalog-item',
          activeKey === item.key && 'active'
        ]"
        @click="scrollTo(item.key)"
      >

        <span class="dot"></span>

        {{ item.title }}

      </div>

    </div>

  </div>
</template>

<script setup>
const props = defineProps({
  menuList: {
    type: Array,
    default: () => []
  },
  activeKey: {
    type: String,
    default: ""
  }
})
// console.log(props.menuList,'menuList')
const emit = defineEmits([

"change"

])

const scrollTo=(key)=>{

  emit("change",key)

}
</script>

<style scoped lang="less">

.workbench-left{

    width:276px;

    position:sticky;

    top:20px;

    align-self:flex-start;

}

.catalog-card{

    background:#fff;

    border-radius:14px;

    border:1px solid #E8EDF5;

    padding:18px;

}

.catalog-title{

    font-size:15px;

    font-weight:700;

    color:#31425E;

    margin-bottom:18px;

}

.catalog-item{

    height:40px;

    border-radius:8px;

    display:flex;

    align-items:center;

    padding:0 14px;

    cursor:pointer;

    transition:.25s;

    color:#64748F;

    font-size:14px;

    margin-bottom:6px;

}

.catalog-item:hover{

    background:#F5F8FF;

}

.catalog-item.active{

    background:#EAF2FF;

    color:#1768FF;

    font-weight:600;

}

.dot{

    width:6px;

    height:6px;

    border-radius:50%;

    background:#1768FF;

    margin-right:10px;

    opacity:0;

}

.catalog-item.active .dot{

    opacity:1;

}

</style>